import { render } from "./ListMenu.vue?vue&type=template&id=6045020c"
import script from "./ListMenu.vue?vue&type=script&lang=js"
export * from "./ListMenu.vue?vue&type=script&lang=js"
script.render = render

export default script